import { LoggedOutView } from '../../../features/logged-out/logged-out-view';

const LoggedOut = () => {
  return <LoggedOutView />;
};

export { LoggedOut };
